import { LinkItem } from '@occc/ui-design-system';
import { SegmentFragment } from '@occc/graphql';

import { State as CSVUploadState } from './components/CSVUpload/redux/types';

const SEGMENTS_BASE_URL = '/segments';

export const routeCreator = {
  base: () => SEGMENTS_BASE_URL,
  create: () => `${SEGMENTS_BASE_URL}/create`,
  details: (id: string) => `${SEGMENTS_BASE_URL}/${id}`,
};

export const getSegmentPageHeaderLinks = (segment: SegmentFragment | null): LinkItem[] => {
  if (!segment) {
    return [];
  }

  return [
    {
      to: routeCreator.base(),
      label: 'Segments',
    },
    {
      key: routeCreator.details(segment.id),
      label: segment.name,
    },
  ];
};

export const csvUploadStateToCopy = (state: CSVUploadState['csvUploads'][0]['state']) => {
  switch (state) {
    case 'inProgress':
      return 'in progress';
    default:
      return state;
  }
};
